import React, { Component } from 'react';
import {StyleSheet, Text, View, Animated, Easing, Image, Pressable} from 'react-native';

import GameData from './GameData';
import TaskImages from './Images';

const fps = 10;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

class SkillRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refresh: false,
    }
    
    this.progressAnim =  new Animated.Value(GameData.skills[this.props.skill].exp / GameData.getExpToNextLvl(this.props.skill));
	this.exp = GameData.skills[props.skill].exp;
	this.lvl = GameData.skills[props.skill].lvl;

  }

	shouldComponentUpdate(nextProps, nextState) {
	if (this.exp != GameData.skills[this.props.skill].exp || this.lvl != GameData.skills[this.props.skill].lvl) {
		this.exp = GameData.skills[this.props.skill].exp;
		this.lvl = GameData.skills[this.props.skill].lvl;
		//this.setState({refresh: !this.state.refresh});
		
		let toValue = GameData.skills[this.props.skill].exp / GameData.getExpToNextLvl(this.props.skill);

		Animated.timing(this.progressAnim, {
		  toValue: toValue,
		  easing: Easing.linear,
		  duration: fpsDuration,
		  useNativeDriver: false,
		}).start();
		
		return true;
	}
	return false;
  }
	
	/*
  componentDidMount() {
    this.interval = setInterval(function() {
            this.refresh();
          }.bind(this), fpsDuration);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
}
*/

  refresh() {
	if (this.exp != GameData.skills[this.props.skill].exp) {
		this.exp = GameData.skills[this.props.skill].exp;
		this.setState({refresh: !this.state.refresh});
		
		let toValue = GameData.skills[this.props.skill].exp / GameData.getExpToNextLvl(this.props.skill);

		Animated.timing(this.progressAnim, {
		  toValue: toValue,
		  easing: Easing.linear,
		  duration: fpsDuration,
		  useNativeDriver: false,
		}).start();
	}

  }

  render() {
    const progressInterpolate =
    this.progressAnim.interpolate({
      inputRange: [0, 1],
      outputRange: ["0%", "100%"]
    });

    return (
      <View style={styles.row}>
        <Animated.View style={[styles.skillProgress,
        {width: progressInterpolate}
      ]}>
        </Animated.View>
        <Text style={styles.skillText} adjustsFontSizeToFit={true} numberOfLines={1}> {GameData.skills[this.props.skill].name} {GameData.skills[this.props.skill].lvl}</Text>
        <Text style={styles.skillExp}>{Math.floor(GameData.skills[this.props.skill].exp)}/{GameData.getExpToNextLvl(this.props.skill)} </Text>
      </View>
    );
  }
}

/*
    return (
      <View style={styles.row}>
        <Animated.View style={[styles.skillProgress,
        {width: progressInterpolate}
      ]}>
        </Animated.View>
        <Image style={styles.logo} source={TaskImages[GameData.skills[this.props.skill].image]} />
        <Text style={styles.skillText} adjustsFontSizeToFit={true} numberOfLines={2}> {GameData.skills[this.props.skill].name} {GameData.skills[this.props.skill].lvl}</Text>
        <Text style={styles.skillExp}>{Math.floor(GameData.skills[this.props.skill].exp)}/{GameData.getExpToNextLvl(this.props.skill)} </Text>
      </View>
    );
*/

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    marginBottom: 0,
    height: 40,
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#ffffff',
  },
  skillProgress: {
    backgroundColor: '#f44336',
    top: 0,
    height: 40,
    position: 'absolute',
    zIndex: -1,
  },
  skillText: {
    color: '#000000',
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
    flex: 1,
	paddingLeft: 5,
  },
  skillExp: {
    color: '#000000',
    fontFamily: 'Alegreya-Regular',
    fontSize: 16,
    flex: 0.2,
    textAlign: 'right',
  },
    logo: {
    margin: 2,
    height: 25,
    width: 25,
  },
});

export default SkillRow;